export default __webpack_public_path__ + "static/media/5.092243c8.jpg";